import { composeIO } from 'react-compose-io'
import { ComponentePaginacaoView } from './ComponentePaginacao'
import { componentePaginacaoIO } from './ComponentePaginacao.IO'

export const ComponentePaginacao = composeIO(ComponentePaginacaoView, componentePaginacaoIO)
